import React from 'react';
import { SITE_BRAND_NAME, SITE_BRAND_LEGACY, SITE_BRAND_TAGLINE_SEO } from '../constants/siteBranding';
import './AboutSection.css';

function AboutSection() {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <h2 className="section-title">About Us</h2>
        <div className="about-content">
          <p>
            <strong>{SITE_BRAND_NAME}</strong> (formerly {SITE_BRAND_LEGACY}) is a leading provider of housekeeping,
            facility management, valet parking, and manpower services in Ahmedabad and Gujarat. We support offices,
            hospitals, retail, societies, and events with trained crews and accountable supervision.
          </p>
          <p>{SITE_BRAND_TAGLINE_SEO}</p>
          <p>
            Our commitment to quality, reliability, and customer satisfaction sets us apart. We combine eco-conscious
            products where suitable with modern cleaning and soft-service practices so your spaces stay safe, presentable,
            and compliant.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
